import { filter, find,keyBy, map, reduce } from "lodash";

import syncApplications from "../../constants/syncApplications";
import SyncCustomFieldOptions from "../../constants/SyncCustomFieldOptions";
import syncLocalFields from "../../constants/syncLocalFields";

const upgradeSync = (v2Data, selectedSyncProject, definitions, eventSummaryProperty, newReferenceIdForV2Id) => {
  let sync = null;
  let furtherSyncConfigRequired = false;

  const syncData = find(v2Data.syncData, d => d.lastProjectPath === selectedSyncProject);

  // Now import sync settings if required
  if (syncData) {
    const app = selectedSyncProject.toLowerCase() === "ulysses" ? syncApplications.ULYSSES : syncApplications.SCRIVENER;
    // TODO: Need to import Ulysses syncing settings
    const path = app === syncApplications.SCRIVENER ? selectedSyncProject : null;

    furtherSyncConfigRequired = app === syncApplications.ULYSSES;

    // Fields that we can still sync are:
    // title => title only
    // summary => synopsis only
    // startDate => custom field [was called Start_rangePropId]
    // endDate => custom field [was called End_rangePropId]

    const v2RangePropId = v2Data.template.rangeProperties[0].guid;
    const v2StartFieldId = `Start_${v2RangePropId}`;
    const v2EndFieldId = `End_${v2RangePropId}`;

    const fields = keyBy(
      filter(
        map(syncData.settings.mappedProperties, (v2AeonField, v2ProjectField) => {
          let localFieldId = null;
          let externalFieldId = null;
          if (v2AeonField === v2StartFieldId) {
            localFieldId = syncLocalFields.start;
            externalFieldId = v2ProjectField;
          } else if (v2AeonField === v2EndFieldId) {
            localFieldId = syncLocalFields.end;
            externalFieldId = v2ProjectField;
          } else if (v2AeonField === v2EndFieldId) {
            localFieldId = syncLocalFields.end;
            externalFieldId = v2ProjectField;
          } else if (v2AeonField === "title" && v2ProjectField === "Title") {
            localFieldId = syncLocalFields.label;
            externalFieldId = SyncCustomFieldOptions.TITLE;
          } else if (v2AeonField === eventSummaryProperty && v2ProjectField === "Synopsis") {
            localFieldId = syncLocalFields.summary;
            externalFieldId = SyncCustomFieldOptions.SYNOPSIS;
          } else {
            // if it was a property in v2, we can still sync it in v3
            const property = definitions.properties.byId[v2AeonField];
            if (property) {
              localFieldId = property.id;
              externalFieldId = v2ProjectField;
            }
            // if it was a property in v2, we can still sync it in v3
            const referenceId = newReferenceIdForV2Id[v2AeonField];

            if (referenceId) {
              const reference = definitions.references.byId[referenceId];
              if (reference) {
                localFieldId = reference.id;
                externalFieldId = v2ProjectField;
              }
            }
          }
          if (!localFieldId && !externalFieldId) {
            return null;
          }
          return {
            id: localFieldId,
            customFieldId: externalFieldId
          };
        }),
        f => f
      ),
      f => f.id
    );

    const settings = {
      enabled: definitions.includeNarrative,
      app,
      useKeywordsForRelationships: false,
      path,
      fields,
      entityFolders: {},
      keywordTypes: []
    };

    const localToExternalIds = reduce(
      syncData.links,
      (result, link) => {
        result[link.eventId] = link.itemId;
        return result;
      },
      {}
    );

    sync = {
      settings,
      localToExternalIds
    };
  }

  return {
    sync,
    furtherSyncConfigRequired
  };
};

export default upgradeSync;
